import type { DragEvent } from 'react';
import type { Project } from '@/api/client';
import { writeProjectChatAttach } from '@/components/Messenger/shared/composer/readChatAttachFromDataTransfer';

/**
 * Перенос строки списка в окно мессенджера (концепт project-to-chat): чат принимает проект и кладёт его над полем ввода.
 * Строка тянется просто мышью (концепт readers-like-authors-copy, 2.1: ⌘ теперь копирует значение); нажатие без сдвига — выбор проекта.
 * За курсором — браузерный снимок самой строки.
 * onDragStartCapture: обработчики onDragStart / onDrag motion забирает под свой жест и до кнопки не доносит.
 */
export function projectChatDragProps(project: Pick<Project, 'id' | 'name'>) {
  return {
    draggable: true,
    onDragStartCapture: (e: DragEvent<HTMLElement>) => writeProjectChatAttach(e.dataTransfer, project),
  };
}
